// This file is responsible for providing icon configurations for labels.
// It maps system label names to specific SVG icons and colors.

// Mappa delle icone SVG per le label di sistema
const SYSTEM_LABEL_ICONS = {
  INBOX: {
    svg: `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" class="flex-shrink-0">
            <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
              <path d="M22 12h-6l-2 3h-4l-2-3H2"/>
              <path d="M5.45 5.11L2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11"/>
            </g>
          </svg>`,
    color: '#4c5155',
  },
  SENT: {
    svg: `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" class="flex-shrink-0">
            <path fill="currentColor" d="M20.33 3.67a1.45 1.45 0 0 0-1.47-.35L4.23 8.2A1.44 1.44 0 0 0 4 10.85l6.07 3l3 6.09a1.44 1.44 0 0 0 1.29.79h.1a1.43 1.43 0 0 0 1.26-1l4.95-14.59a1.41 1.41 0 0 0-.34-1.47M4.85 9.58l12.77-4.26l-7.09 7.09Zm9.58 9.57l-2.84-5.68l7.09-7.09Z"/>
          </svg>`,
    color: '#4c5155',
  },
  DRAFT: {
    svg: `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" class="flex-shrink-0">
            <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
              <path d="M7 7H6a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-1"/>
              <path d="M20.385 6.585a2.1 2.1 0 0 0-2.97-2.97L9 12v3h3l8.385-8.415Z"/>
              <path d="m16 5 3 3"/>
            </g>
          </svg>`,
    color: '#4c5155',
  },
  TRASH: {
    svg: `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" class="flex-shrink-0"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 7h16m-10 4v6m4-6v6M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2l1-12M9 7V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v3"/></svg>`,
    color: '#4c5155',
  },
  ARCHIVE: {
    svg: `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="currentColor" class="flex-shrink-0"><path d="M20.54 5.23l-1.39-1.68C18.88 3.21 18.47 3 18 3H6c-.47 0-.88.21-1.16.55L3.46 5.23C3.17 5.57 3 6.02 3 6.5V19c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V6.5c0-.48-.17-.93-.46-1.27zM6.24 5h11.52l.83 1H5.42l.82-1zM5 19V8h14v11H5zm11-5.5l-4 4-4-4 1.41-1.41L11 13.67V10h2v3.67l1.59-1.58L16 13.5z"/></svg>`,
    color: '#4c5155',
  },
  SPAM: {
    svg: `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" class="flex-shrink-0">
            <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
              <path d="M12 9v4M10.363 3.591l-8.106 13.534a1.914 1.914 0 0 0 1.636 2.871h16.214a1.914 1.914 0 0 0 1.636-2.87L13.637 3.59a1.914 1.914 0 0 0-3.274 0zM12 16h.01"/>
            </g>
          </svg>`,
    color: '#4c5155',
  },
  STARRED: {
    svg: `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" class="flex-shrink-0"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.12 2.12 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.12 2.12 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.12 2.12 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16z"/></svg>`,
    color: '#4c5155',
  },
  IMPORTANT: {
    svg: `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" class="flex-shrink-0">
            <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
              <path d="M12 8v4M12 16h.01M21 12c0 4.97-4.03 9-9 9s-9-4.03-9-9 4.03-9 9-9 9 4.03 9 9z"/>
            </g>
          </svg>`,
    color: '#4c5155',
  },
  UNREAD: {
    svg: `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 32 32" class="flex-shrink-0">
            <path fill="currentColor" d="M27 10a4 4 0 1 0 0-8a4 4 0 0 0 0 8M6.5 5h15.09a5.5 5.5 0 0 0 0 2H6.5A2.5 2.5 0 0 0 4 9.5v.903l12 6.461l10.1-5.437q.44.073.901.073a5.47 5.47 0 0 0 3-.89V22.5a4.5 4.5 0 0 1-4.5 4.5h-19A4.5 4.5 0 0 1 2 22.5v-13A4.5 4.5 0 0 1 6.5 5M4 12.674V22.5A2.5 2.5 0 0 0 6.5 25h19a2.5 2.5 0 0 0 2.5-2.5v-9.826l-11.526 6.207a1 1 0 0 1-.948 0z"/>
          </svg>`,
    color: '#4c5155',
  },
  CHAT: {
    svg: `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" class="flex-shrink-0">
            <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
              <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
            </g>
          </svg>`,
    color: '#4c5155',
  },
  SNOOZED: {
    svg: `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" class="flex-shrink-0">
            <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
              <circle cx="12" cy="12" r="10"/>
              <polyline points="12,6 12,12 16,14"/>
            </g>
          </svg>`,
    color: '#4c5155',
  },
  SCHEDULED: {
    svg: `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" class="flex-shrink-0"><path fill="currentColor" d="M2.3 3.272L5.693 12l-3.395 8.728l-.03.096a.75.75 0 0 0 1.065.847l7.674-3.838a6.6 6.6 0 0 1 .147-1.75L4.402 19.46l2.61-6.71h6.051a6.5 6.5 0 0 1 1.3-.944a.75.75 0 0 0-.724-.556H7.01L4.402 4.54l12.924 6.462L17.5 11c1.553 0 2.98.545 4.098 1.454a.752.752 0 0 0-.264-1.125l-18-9l-.093-.04c-.586-.206-1.178.375-.942.983M23 17.5a5.5 5.5 0 1 0-11 0a5.5 5.5 0 0 0 11 0M17.5 14a.5.5 0 0 1 .5.5V17h2a.5.5 0 0 1 0 1h-2.5a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 .5-.5"/></svg>`,
    color: '#5F6368',
  },
  AI_REPLIED: {
    svg: `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 64 64" fill="currentColor" class="flex-shrink-0"><path d="M4.15601 7.93C3.34201 5.4 5.97601 3.14 8.35401 4.328L58.342 29.318C60.554 30.424 60.554 33.578 58.342 34.686L8.35401 59.676C5.97801 60.864 3.34201 58.604 4.15601 56.074L11.9 32.002L4.15601 7.93ZM15.456 34.002L8.69401 55.034L54.768 32.002L8.69201 8.97L15.46 30H38C38.5304 30 39.0392 30.2107 39.4142 30.5858C39.7893 30.9609 40 31.4696 40 32C40 32.5304 39.7893 33.0391 39.4142 33.4142C39.0392 33.7893 38.5304 34 38 34L15.456 34.002Z"/><path d="M51.4146 3.40393C50.9913 3.13994 50.5024 3 50.0035 3C49.4468 2.99967 48.904 3.17357 48.4511 3.49733C47.9982 3.82109 47.658 4.27847 47.4782 4.80533L46.5448 7.544L43.8088 8.47733L43.4942 8.60534C43.0199 8.8375 42.6253 9.20522 42.3603 9.6619C42.0952 10.1186 41.9717 10.6437 42.0054 11.1706C42.0391 11.6976 42.2285 12.2026 42.5496 12.6218C42.8706 13.041 43.3089 13.3555 43.8088 13.5253L46.5475 14.4587L47.4808 17.1947L47.6088 17.5067C47.8408 17.981 48.2083 18.3758 48.6648 18.641C49.1213 18.9063 49.6463 19.03 50.1732 18.9966C50.7001 18.9632 51.2053 18.7741 51.6246 18.4533C52.044 18.1325 52.3587 17.6945 52.5288 17.1947L53.4622 14.456L56.1982 13.5227L56.5128 13.3947C56.9871 13.1625 57.3817 12.7948 57.6468 12.3381C57.9118 11.8814 58.0353 11.3563 58.0016 10.8294C57.9679 10.3025 57.7785 9.79737 57.4575 9.37817C57.1364 8.95897 56.6981 8.64452 56.1982 8.47467L53.4595 7.54134L52.5262 4.80533L52.3982 4.49333C52.1787 4.04534 51.8379 3.66791 51.4146 3.40393Z"/></svg>`,
    color: '#5F6368',
  },
  // Categorie Gmail
  CATEGORY_PERSONAL: {
    svg: `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" class="flex-shrink-0">
            <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
              <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
              <circle cx="12" cy="7" r="4"/>
            </g>
          </svg>`,
    color: '#4c5155',
  },
  CATEGORY_SOCIAL: {
    svg: `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" class="flex-shrink-0">
            <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
              <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/>
              <circle cx="9" cy="7" r="4"/>
              <path d="m22 21-3-3M16 3.13a4 4 0 0 1 0 7.75"/>
            </g>
          </svg>`,
    color: '#4c5155',
  },
  CATEGORY_PROMOTIONS: {
    svg: `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" class="flex-shrink-0">
            <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
              <path d="m3 11 18-5v12L3 14v-3z"/>
              <path d="M11.6 16.8a3 3 0 1 1-5.8-1.6"/>
            </g>
          </svg>`,
    color: '#4c5155',
  },
  CATEGORY_UPDATES: {
    svg: `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" class="flex-shrink-0">
            <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
              <circle cx="12" cy="12" r="10"/>
              <path d="M12 6v6l4 2"/>
            </g>
          </svg>`,
    color: '#4c5155',
  },
  CATEGORY_FORUMS: {
    svg: `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" class="flex-shrink-0">
            <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
              <path d="M14 9a2 2 0 0 1-2 2H6l-4 4V4c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2v5z"/>
              <path d="M18 9h2a2 2 0 0 1 2 2v11l-4-4h-6a2 2 0 0 1-2-2v-1"/>
            </g>
          </svg>`,
    color: '#4c5155',
  },
  CATEGORY: {
    svg: `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" class="flex-shrink-0">
            <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
              <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"/>
            </g>
          </svg>`,
    color: '#4c5155',
  },
  NOTE: {
    svg: `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="currentColor" class="flex-shrink-0"><path d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2h-8l-2-2z"/></svg>`,
    color: '#4c5155',
  },
  DEFAULT_USER_LABEL: {
    svg: `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="currentColor" class="flex-shrink-0"><path d="M4 20q-.825 0-1.412-.587T2 18V6q0-.825.588-1.412T4 4h6l2 2h8q.825 0 1.413.588T22 8v10q0 .825-.587 1.413T20 20zm0-2h16V8h-8.825l-2-2H4zm0 0V6z"/></svg>`,
    color: '#4c5155',
  },
};

// Icona generica per label user
const USER_LABEL_ICON = {
  svg: `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" class="flex-shrink-0">
          <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
            <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"/>
          </g>
        </svg>`,
  color: '#4c5155',
};

// Lista delle label di sistema per identificazione
const SYSTEM_LABEL_TITLES = [
  'INBOX',
  'SENT',
  'DRAFT',
  'TRASH',
  'SPAM',
  'STARRED',
  'IMPORTANT',
  'UNREAD',
  'CHAT',
  'SNOOZED',
  'ARCHIVE',
  'CATEGORY_PERSONAL',
  'CATEGORY_SOCIAL',
  'CATEGORY_PROMOTIONS',
  'CATEGORY_UPDATES',
  'CATEGORY_FORUMS',
  'CATEGORY',
  'NOTE',
];

// Nomi delle cartelle di sistema nelle lingue dei clienti (it, en, de, fr, es, pt),
// verso il ruolo. Specchio di Labels::FolderRole::TITLE_ROLES in otello-core: serve
// solo dove arriva un titolo senza `system_role` (titolo della rotta, label vecchie).
const FOLDER_TITLE_ROLES = {
  INBOX: [
    'INBOX',
    'POSTA IN ARRIVO',
    'POSTEINGANG',
    'BOÎTE DE RÉCEPTION',
    'BANDEJA DE ENTRADA',
    'RECIBIDOS',
    'CAIXA DE ENTRADA',
  ],
  SENT: [
    'SENT',
    'SENT ITEMS',
    'SENT MESSAGES',
    'SENT MAIL',
    'POSTA INVIATA',
    'INVIATA',
    'INVIATI',
    'ELEMENTI INVIATI',
    'GESENDET',
    'GESENDETE ELEMENTE',
    'GESENDETE OBJEKTE',
    'ÉLÉMENTS ENVOYÉS',
    'MESSAGES ENVOYÉS',
    'ENVOYÉS',
    'ENVOYÉ',
    'COURRIER ENVOYÉ',
    'ELEMENTOS ENVIADOS',
    'ENVIADOS',
    'ITENS ENVIADOS',
  ],
  DRAFT: [
    'DRAFTS',
    'DRAFT',
    'BOZZE',
    'ENTWÜRFE',
    'BROUILLONS',
    'BROUILLON',
    'BORRADORES',
    'RASCUNHOS',
  ],
  TRASH: [
    'TRASH',
    'BIN',
    'DELETED',
    'DELETED ITEMS',
    'DELETED MESSAGES',
    'CESTINO',
    'POSTA ELIMINATA',
    'ELEMENTI ELIMINATI',
    'ELIMINA ELEMENTI',
    'PAPIERKORB',
    'GELÖSCHTE ELEMENTE',
    'GELÖSCHTE OBJEKTE',
    'ÉLÉMENTS SUPPRIMÉS',
    'MESSAGES SUPPRIMÉS',
    'SUPPRIMÉS',
    'CORBEILLE',
    'ELEMENTOS ELIMINADOS',
    'PAPELERA',
    'ITENS EXCLUÍDOS',
    'LIXEIRA',
    'LIXO',
  ],
  SPAM: [
    'SPAM',
    'JUNK',
    'JUNK E-MAIL',
    'JUNK EMAIL',
    'BULK MAIL',
    'POSTA INDESIDERATA',
    'JUNK-E-MAIL',
    'SPAM-VERDACHT',
    'COURRIER INDÉSIRABLE',
    'COURRIERS INDÉSIRABLES',
    'INDÉSIRABLES',
    'POURRIEL',
    'POURRIELS',
    'CORREO NO DESEADO',
    'LIXO ELETRÔNICO',
  ],
  ARCHIVE: ['ARCHIVE', 'ARCHIVES', 'ARCHIVIO', 'ARCHIV', 'ARCHIVO', 'ARQUIVO'],
  OUTBOX: [
    'OUTBOX',
    'POSTA IN USCITA',
    'POSTAUSGANG',
    "BOÎTE D'ENVOI",
    'BANDEJA DE SALIDA',
    'CAIXA DE SAÍDA',
  ],
};

// Accenti e apostrofi non contano: molti server IMAP salvano "Elements envoyes"
// o "Boîte d’envoi" con l'apostrofo tipografico.
const normalizeFolderTitle = (title) =>
  String(title || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[’`´]/g, "'")
    .replace(/\s+/g, ' ')
    .trim()
    .toUpperCase();

const FOLDER_TITLE_TO_ROLE = Object.fromEntries(
  Object.entries(FOLDER_TITLE_ROLES).flatMap(([role, titles]) =>
    titles.map((title) => [normalizeFolderTitle(title), role])
  )
);

// Cartelle che non hanno un ruolo (niente traduzione) ma un'icona propria.
const ICON_ONLY_TITLES = {
  SCHEDULED: 'SCHEDULED',
  AI_REPLIED: 'AI_REPLIED',
  'CRONOLOGIA DELLE CONVERSAZIONI': 'ARCHIVE',
  'CONVERSATION HISTORY': 'ARCHIVE',
  NOTE: 'NOTE',
  NOTES: 'NOTE',
};

/**
 * Ruolo di una cartella (INBOX, SENT, DRAFT, TRASH, SPAM, ARCHIVE, OUTBOX o
 * un id di sistema Gmail), indipendente dalla lingua della casella.
 * Le label della sidebar portano `system_role` calcolato dal backend sugli id
 * stabili del provider; senza, si ripiega sul titolo.
 * @param {Object} label - Oggetto label
 * @returns {string|null}
 */
export const resolveFolderRole = (label) => {
  if (!label || !label.title) return null;
  if (label.system_role !== undefined) return label.system_role || null;

  if (label.folder_type === 'user') return null;
  const title = label.title.trim().toUpperCase();
  if (SYSTEM_LABEL_TITLES.includes(title) && title !== 'NOTE') return title;
  return FOLDER_TITLE_TO_ROLE[normalizeFolderTitle(title)] || null;
};

/**
 * Determina se una label è di tipo sistema
 * @param {Object} label - Oggetto label
 * @returns {boolean}
 */
export const isSystemLabel = (label) => {
  if (!label) return false;

  return label.folder_type === 'system' || Boolean(resolveFolderRole(label));
};

/**
 * Ottiene la configurazione dell'icona per una label
 * @param {Object} label - Oggetto label
 * @returns {Object} Configurazione con svg e color
 */
export const getLabelIconConfig = (label) => {
  if (!label || !label.title) {
    return SYSTEM_LABEL_ICONS.DEFAULT_USER_LABEL;
  }

  const iconKey =
    resolveFolderRole(label) ||
    ICON_ONLY_TITLES[label.title.trim().toUpperCase()];

  return SYSTEM_LABEL_ICONS[iconKey] || SYSTEM_LABEL_ICONS.DEFAULT_USER_LABEL;
};

/**
 * Funzione factory per creare il configuratore di icone
 * Utile per computed properties nei componenti Vue
 * @returns {Function}
 */
export const createLabelIconConfig = () => getLabelIconConfig;

/**
 * Ottiene le informazioni per tradurre una label
 * @param {Object} label - Oggetto label
 * @returns {Object} Oggetto con translationKey, isSystemLabel e originalTitle
 */
export const getLabelTranslationInfo = (label) => {
  if (!label || !label.title)
    return { originalTitle: '', isSystemLabel: false, translationKey: null };

  // Le cartelle con un ruolo si traducono nella lingua dell'interfaccia, qualunque
  // sia la lingua della casella; le altre tengono il nome che hanno nel provider.
  const role = resolveFolderRole(label);
  return {
    originalTitle: label.title,
    isSystemLabel: isSystemLabel(label),
    translationKey: role ? `CHAT_LIST.SYSTEM_LABELS.${role}` : null,
  };
};

/**
 * Ottiene il titolo tradotto per una label
 * @param {Object} label - Oggetto label
 * @param {Function} t - Funzione di traduzione Vue i18n
 * @returns {string} Titolo tradotto o originale
 * @deprecated Usa getLabelTranslationInfo invece per evitare problemi di contesto
 */
export const getTranslatedLabelTitle = (label, t) => {
  const info = getLabelTranslationInfo(label);

  if (info.isSystemLabel && info.translationKey && t) {
    const translated = t(info.translationKey);
    // Se la traduzione esiste e non è uguale alla chiave, usala
    if (translated && translated !== info.translationKey) {
      return translated;
    }
  }

  return info.originalTitle;
};

// Export per compatibilità
export { SYSTEM_LABEL_ICONS, USER_LABEL_ICON, SYSTEM_LABEL_TITLES };
